export default __webpack_public_path__ + "static/media/richtext-editor.83a863f3.svg";